// import { useSelector } from "react-redux";

const ItemSelected = (props) => {
	// const {subscriptions} = useSelector(state => state);
	// const selectedItem = subscriptions?.selectedItem;
	return (props.children);
};

export default ItemSelected;
